module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/pierata.176f3d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/pierata.jpg
// module id = VJ4C
// module chunks = 0